<template>
  <div>
    <Header />
    <section class="mt-5 marketplace" id="app">
      <div class="container-fluid pl-5">
        <div class="row">
          <div class="col-10 mx-auto col-md-3 col-lg-2 mb-5">
            <Sidebar />
          </div>

          <div class="col-12 col-md-9 col-lg-10">
            <div class="row">
              <div class="col-12">
                <h5 class="text-center mb-5">
                  <span style="font-weight: 700;">Market Place: </span>The best
                  graded produce available at scale from local farmers.
                </h5>
              </div>

              <div
                class="col-sm-4 col-md-7 col-lg-5 text-center mb-3"
                id="product_details"
              >
                <product-carousel></product-carousel>
                <h4 class="font-weight-bold">Soyabeans</h4>
              </div>

              <div
                class="col-sm-4 col-md-5 col-lg-4 text-center mb-3 px-3 px-md-0 pl-md-3"
                id="popup-origination"
              >
                <transition name="fade">
                  <div
                    id="origination"
                    class="popup shadow-custom border border-dark py-5 px-2"
                    v-cloak
                    v-show="isOriginationClicked"
                  >
                    <div class="h5">Origination</div>
                    <div
                      class="close-popup bg-dark rounded-circle px-3 py-2 font-weight-bold text-white roboto"
                      @click="isOriginationClicked = !isOriginationClicked"
                    >
                      <font-awesome-icon :icon="['fas', 'times']" size="1x" />
                    </div>

                    <p>
                      Location:<br />
                      This produce was aggregated in Kumo local government, in
                      Gombe State from small holder farmers.
                    </p>

                    <p>
                      <b>Seed details:</b><br />
                      <b>Variety:</b> Soyabeans<br />
                      <b>Fertilizer used:</b>NPK
                      <br />
                      <b>Soil quality:</b> <br />
                    </p>

                    <p>
                      <b>Produce detail</b><br />
                      <b>Colour:</b> Brown<br />
                      <b>Size:</b> 3-6 mm <br />
                      <b>Weight:</b> 100 Kg <br />
                    </p>

                    <p><b>Designation detail: </b>Inorganic</p>
                  </div>
                </transition>

                <div class="details text-left" v-show="!isOriginationClicked">
                  <h5 class="font-weight-bold">Product Description</h5>
                  <div class="price my-3">
                    <span class="h5 font-weight-bold">Price:</span>
                    <span class="h5">{{ product.price | currency }}</span
                    >/ Tonne.
                  </div>
                  <div class="quantity my-4">120,000 Tonnes available</div>

                  <div class="choose row align-items-center">
                    <div class="col-3"><b>Choose Quantity</b></div>
                    <div class="col-9 col-lg-8">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <!-- <span class="input-group-text" id="">First and last name</span> -->
                        </div>
                        <select
                          class="small form-control border border-dark px-2 py-0 rounded-0"
                          style="max-width:90px"
                          v-model="selectedWeightRange"
                        >
                          <option value="kg">Kg</option>
                          <option value="tonne">Tonne</option>
                        </select>
                        <select
                          class="form-control border border-dark py-0 px-2 rounded-0"
                          v-model.number="qty"
                        >
                          <option value disabled selected>Choose Qty</option>
                          <option v-if="selectedWeightRange == 't'" value="1"
                            >1 tonne</option
                          >
                          <option
                            v-for="weight in weightRange"
                            :key="weight"
                            :value="weight"
                            >{{ weight }} {{ selectedWeightRange }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="px-4">
                    <div class="grades my-4">
                      <div class="h6">Grades available:</div>
                      <div class="form-group mb-0 text-left ">
                        <input
                          type="radio"
                          v-model="grade"
                          value="export"
                          id="export"
                          class="mr-3"
                        />
                        <label for="export">Export Grade</label>
                      </div>
                      <div class="form-group mb-0 text-left ">
                        <input
                          type="radio"
                          v-model="grade"
                          value="grade 1"
                          id="grade1"
                          class="mr-3"
                        />
                        <label for="grade1">Grade 1</label>
                      </div>
                      <div class="form-group mb-0 text-left ">
                        <input
                          type="radio"
                          v-model="grade"
                          value="grade 2"
                          id="grade2"
                          class="mr-3"
                        />
                        <label for="grade2">Grade 2</label>
                      </div>
                      <div class="form-group mb-0 text-left ">
                        <input
                          type="radio"
                          v-model="grade"
                          value="grade 3"
                          id="grade3"
                          class="mr-3"
                        />
                        <label for="grade3">Grade 3</label>
                      </div>
                    </div>

                    <div class="origin my-4">
                      <div class="h6 text-center w-50">
                        <a
                          href="javascript:void(0)"
                          class="btn btn-light btn-pill text-dark border border-dark py-1 px-3"
                          v-on:click="
                            isOriginationClicked = !isOriginationClicked
                          "
                          >Origination</a
                        >
                      </div>
                      <button
                        href="javascript:void(0)"
                        data-name="Soyabeans"
                        data-id="1"
                        data-price="140000"
                        data-currency="NGN"
                        data-quantity="3"
                        @click="addToCart(product.id)"
                        class="add-to-cart btn btn-black btn-pill py-3 px-4"
                      >
                        Add to Order
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-7 mx-auto col-lg-3 text-center my-3">
                <Advert />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
    <market-price />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import MarketPrice from "@/components/MarketPrice.vue";
import Sidebar from "@/components/MarketSidebar.vue";
import Advert from "@/components/Advert.vue";
import ProductCarousel from "@/components/ProductCarousel.vue";
import { cartMixin, weightMixin } from "@/_mixins";

export default {
  mixins: [weightMixin, cartMixin],
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | MarketPlace",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },

  components: { Header, Footer, MarketPrice, ProductCarousel, Sidebar, Advert },

  data() {
    return {
      product: {
        id: 1,
        value: "soyabean",
        name: "Soyabean",
        price: 50000,
        grades: [
          {
            name: "grade 1",
            price: 50000
          },
          {
            name: "grade 2",
            price: 60000
          },
          {
            name: "grade 3",
            price: 70000
          }
        ]
      },
      qty: 0,
      grade: "grade 2",
      isOriginationClicked: false
    };
  },

  mounted() {
    this.product &&
      this.isProductInCart(this.product.id) &&
      this.persistFormData(this.product.id);
  },

  computed: {
    ...mapGetters("cart", ["cartItems", "products"])
  },

  methods: {
    ...mapActions("cart", ["updateCartItem"]),

    addToCart(productID) {
      let product = this.products.find(item => item.id === productID);
      let selectedItem = {
        ...product,
        ...{ qty: this.qty },
        ...{ grade: this.grade },
        ...{ weight: this.selectedWeightRange }
      };

      if (!this.isProductInCart(productID)) {
        this.addItem(selectedItem);
      } else {
        let payload = { productID, selectedItem };
        this.getItem(payload);
      }
      this.$router.push({ name: "cart" });
    },

    persistFormData(id) {
      let productInCart = this.cartItems.find(item => item.id == id);
      let position = this.cartItems.indexOf(productInCart);
      this.qty = this.cartItems[position].qty;
      this.grade = this.cartItems[position].grade;
      this.selectedWeightRange = this.cartItems[position].weight;
    },

    getItem(cartItem) {
      let { productID: id, selectedItem: item } = cartItem;

      let productInCart = this.cartItems.find(item => item.id == id);
      let position = this.cartItems.indexOf(productInCart);

      const payload = { position, item };

      this.updateCartItem(payload);
    },

    isProductInCart(productID) {
      let product = this.cartItems.filter(item => item.id === productID);
      return product.length == 0 ? false : true;
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all cubic-bezier(0.68, -0.55, 0.27, 1.55) 0.4s;
}
</style>
